import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { FEATURES } from "../../../utils/constant";

const Columns = [
  { headerName: "State Code", field: "cityCode", sortable: true, filter: true },
  { headerName: "State Name", field: "cityName", sortable: true, filter: true },
  {
    headerName: "Edit / Delete",
    field: "edit",
    cellRenderer: "actionRenderer",
    pinned: "right",
    suppressToolPanel: true,
  },
];

export default class State extends Component {
  state = {
    rowData: [],
    columnDefs: [],
    loadingData: true,
  };
  async componentDidMount() {
    let dataArray = [];
    dataArray = await ReadAxios({ url: "cityMaster" });
    this.setState({
      columnDefs: Columns,
      rowData: dataArray,
      loadingData: false,
    });
  }

  render() {
    const { rowData, columnDefs } = this.state;
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={columnDefs}
          rowData={rowData}
          titleBarTitle={"State"}
          titleBarLink={"/add-state"}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
